import axios from "axios";
import {createURL} from "./client";

// fetchActiveMissions загружает активные миссии с сервера
export function fetchActiveMissions() {
    return axios.get(createURL("/api/missions/active"));
}

// claimMissionReward вызывает API получения награды за миссию
export function claimMissionReward(id) {
    return axios.post(createURL(`/api/missions/${id}/claim`));
}
